<template>
  <v-container
    fluid
    grid-list-md
    text-xs-center
    style="min-height: 100vh;"
  >
    <v-layout
      row
      wrap
      style="min-height: 100vh;"
    >
      <v-toolbar
        scroll-target="#scrolling-home"
        class="workshop-toolbar"
      >
        <v-layout
          style="height: 100%"
        >
          <v-flex
            xs2
            class="centerContent"
          >
            <v-toolbar-title>
              <div
                class="centerContent"
              >
                <div
                  class="d-inline-block"
                >
                  Días de asueto
                </div>
              </div>
            </v-toolbar-title>
          </v-flex>
          <v-flex
            xs10
          >
            <v-layout 
              wrap
              row
              class="centerContent"
            >
              <v-flex
                xs4
              >
                <v-autocomplete
                  v-model="yearFilter"
                  :items="years"
                  :item-text="typeTextss"
                  item-value="type"
                  label="Fecha"
                  required
                />
              </v-flex>
              <v-flex
                xs8
                class="padding-flex"
              >
                <v-layout>
                  <v-flex 
                    class="titleSearch"
                  >
                    <v-text-field
                      flat
                      label="Buscar"
                      append-outer-icon="search"
                      @click:append-outer="filterSearch"
                      @click:clear="filterSearchClear"
                      @keyup.enter="filterSearch"
                      solo-inverted
                      v-model="filters.search"
                      clearable
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-tooltip
          right
        >
          <v-btn
            color="gradiente"
            dark
            small
            absolute
            bottom
            left
            fab
            slot="activator"
            @click="CreateHoliday = true; holidayEditObject = undefined"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Crear dia de asueto</span>
        </v-tooltip>
      </v-toolbar>
      <v-container
        fluid
        elevation-2
        style="min-height: 100vh;"
        class="scrollDesign table-full"
        grid-list-md
      >
        <v-layout
          row
          wrap
        >
          <v-flex>
            <v-data-table
              :headers="headers"
              :rows-per-page-items="[ 25, 50, 100]"
              rows-per-page-text="Registros por página"
              :items="holidays"
              :pagination.sync="pagination"
              :total-items="totalItemsFromBackend"
              item-key="id"
              :loading="working"
              no-results-text="No se encontraron coincidencias"
            >
              <template v-slot:headers>
                <tr>
                  <th class="table-row-size">
                    Descripción
                  </th>
                  <th class="table-row-size">
                    Fecha
                  </th>
                  <th class="table-row-size">
                    Tipo de día
                  </th>
                  <th class="table-row-size">
                    Instructor
                  </th>
                  <th class="table-row-options-size" />
                </tr>
              </template>
              <template v-slot:items="props">
                <tr>
                  <td class="table-row-size">
                    {{ props.item.holidayDescription }} 
                  </td>
                  <td class="table-row-size">
                    {{ props.item.holidayStrHoliday }} 
                  </td>
                  <td class="table-row-size">
                    {{ props.item.holidayType === "G" ? "Global" : "Colaborador" }} 
                  </td>
                  <td class="table-row-size">
                    {{ getEmployeeName(props.item) }} 
                  </td>
                  <td class="centerContent">
                    <div
                      class="icon items-in-block over ml-3"
                      @click="deleteHoliday(props.item)"
                    >
                      <v-icon>
                        delete
                      </v-icon>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-slot:pageText="props">
                {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-layout>
    <create-holiday
      v-model="CreateHoliday"
      :roomHoliday="holidayEditObject"
      @close="closeCreateHoliday"
    />
    <simple-confirm
      v-model="confirmDialog"
      :message="messageConfirm"
      @save="confirmSave"
    />
    <success
      v-model="toast.success"
      text="Operación Exitosa"
    />
    <error
      v-model="toast.failed"
      text="Ups ocurrió un error"
    /> 
    <!--<enrolled-student
      v-model="modals.enrolledStudent"
      :workshopEdit="holidayEditObject"
      :isEnrolled="isEnrolled"
      @close="closeDetails"
    />
    -->
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex';
import { isEmptyOrNull } from '../../../plugins/GeneralMethods';
import Error from '../../Dialogs/Error.vue';
import Success from '../../Dialogs/Success.vue';
import CreateHoliday from '../../Modals/holidays/CreateHoliday.vue';
import SimpleConfirm from '../../Modals/workshops/SimpleConfirm.vue';

export default {
    components: {
        CreateHoliday,
        Success,
        Error,
        SimpleConfirm
    },
    data: () => ({
      headers: [
        {
          text: "Nombre del salón",
          filterItems: [],
        }
      ],
      selected: [],
      holidayEditObject: {}, 
      holidays: [],
      CreateHoliday: false,
      confirmDialog: false,
      toast: {
        success: false,
        failed: false
      },
      filters: {
        search: "",
        offset: 0,
        size: 25,
        employee: {},
        type: []
      },
      yearFilter: new Date().getFullYear(),
      messageConfirm: "",
      holidaySelected: {},
      totalItemsFromBackend: 0,
      pagination: {},
      years: [],
      working: false

    }),
    mounted() {
      this.instanceYears()
    },
    computed: {
      ...mapGetters(["getBranch"]),
    },
    watch: {
      pagination: {
        handler() {
           this.getHolidays();
        },
        deep: true
      },
      yearFilter: {
        handler() {
          this.getHolidays()
        }
      },
      getBranch(){
        this.getHolidays();
      },
    },
    methods: {
      instanceYears(){
        var date = new Date().getFullYear();
        this.years.push(date)
        for (let index = 1; index < 3; index++) {
          this.years.push(date - index)
        }
      },
      typeText(type){
        return type.name
      },
      filterStatus() {
        this.getHolidays();
      },
      filterSearch(){
        this.getHolidays()
      },
      filterSearchClear(){
        this.filters.search = ""
        this.getHolidays()
      },
      toggleAll() {
        if (this.selected.length) this.selected = [];
        else this.selected = this.$refs.table.filteredItems.slice();
      },
      closeCreateHoliday(){
        this.getHolidays()
      },
      getHolidays(){
        if (this.getBranch.id == null) {
          return
        }
        let pageSize = this.pagination.rowsPerPage == -1 ? this.totalNotices : this.pagination.rowsPerPage;
        let currentPage = this.pagination.page - 1;
        let offset = currentPage * pageSize;
        const body = {
            "search": this.filters.search,
            "offset": offset,
            "size": pageSize,
            "year": this.yearFilter
        }
        this.$store
          .dispatch("holiday/getHolidays", body)
          .then(response => {
            this.holidays = response.data.entity
            this.totalItemsFromBackend = response.data.size
            // this.working = false
          })
          .catch(error => {
              this.toast.failed = true
              this.collaborators = [];
          });

      },
      deleteHoliday(holiday) {
        this.holidayEditObject  = holiday
        this.messageConfirm = "¿Estas seguro de que quieres eliminar el dia de asueto?"
        this.confirmDialog = true
      },
      confirmSave(){
        const data = [ {holidayId: this.holidayEditObject.holidayId} ]
        this.$store
          .dispatch("holiday/deleteHoliday", data)
          .then(() => {
            this.toast.success = true
            this.getHolidays()
          })
          .catch(() => {
            this.toast.failed = true
          });
      },
      getEmployeeName(item){
        if (!isEmptyOrNull(item.employee)) {
          var name = item.employee.firstName
          var lastName = item.employee.lastName
          return name + " " + lastName
        }else{
          return ""
        }
      }
    }
}
</script>

<style scoped>

.my-workshop-toolbar {
    z-index: 1; 
    height: 140px;
}

.my-workshop-toolbar .v-toolbar__content {
  height: 140px !important;
}


.table-row-size {
  width: 250px !important; 
  max-width: 250px !important; 
  min-width: 250px !important;
}

.table-row-options-size {
  width: 150px !important; 
  max-width: 150px !important; 
  min-width: 150px !important;
}

.table-checkbox-size {
  width: 10% !important; 
  max-width: 10% !important; 
  min-width: 10% !important;

}

.items-in-block {
  display: inline-block;
}

/deep/ .main-tool-bar .v-toolbar__content{
  height: auto !important;
}

/deep/ .table-full .v-datatable.v-table > tbody{
  max-height: calc(106vh - 426px);
  min-height: calc(106vh - 426px);
}
</style>